if (!customElements.get('paramicafe-card-options')) {
  customElements.define('paramicafe-card-options', class extends HTMLElement {
    connectedCallback() {
      this.card = this.closest('.card');
      this.opener = this.card?.querySelector('modal-opener button[data-product-url]');
      if (!this.opener) {
        this.hidden = true;
        this.style.display = 'none';
        return;
      }
      this.baseUrl = this.opener.getAttribute('data-product-url');
      this.onChange = () => {
        const fields = Array.from(this.querySelectorAll('fieldset'));
        const selected = fields.map(field => field.querySelector('input:checked'));
        const complete = selected.every(Boolean);
        const url = new URL(this.baseUrl, window.location.origin);
        if (complete) {
          url.searchParams.delete('variant');
          url.searchParams.set('option_values', selected.map(input => input.value).join(','));
          this.opener.setAttribute('data-product-url', url.pathname + url.search + url.hash);
        } else {
          this.opener.setAttribute('data-product-url', this.baseUrl);
        }
        this.querySelector('[role="status"]').textContent = '';
      };
      this.onOpen = event => {
        const fields = Array.from(this.querySelectorAll('fieldset'));
        const chosen = fields.filter(field => field.querySelector('input:checked'));
        if (chosen.length === 0 || chosen.length === fields.length) {
          this.onChange();
          return;
        }
        event.preventDefault();
        event.stopImmediatePropagation();
        const missing = fields.filter(field => !field.querySelector('input:checked'));
        const names = missing.map(field => field.querySelector('legend').textContent.trim());
        this.querySelector('[role="status"]').textContent = 'Completa tu selección: ' + names.join(', ') + '.';
        missing[0].querySelector('input')?.focus();
      };
      this.addEventListener('change', this.onChange);
      this.opener.addEventListener('click', this.onOpen, true);
    }
    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
      this.opener?.removeEventListener('click', this.onOpen, true);
    }
  });
}